import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import Divider from '@mui/material/Divider'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { Fragment, useEffect, useState } from 'react'

import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard'
import FactoryIcon from '@mui/icons-material/Factory'
import HelpCenterIcon from '@mui/icons-material/HelpCenter'
import LogoutIcon from '@mui/icons-material/Logout'
import MapIcon from '@mui/icons-material/Map'
import MenuIcon from '@mui/icons-material/Menu'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import SellIcon from '@mui/icons-material/Sell'
import StoreIcon from '@mui/icons-material/Store'


import { DataGrid } from '@mui/x-data-grid'

import styled from '@emotion/styled'
import { Paper } from '@mui/material'
import { Link } from 'wouter'
import { getServerVersion } from './api'
import Account from './pages/Account'
import ClaimedLabels from './pages/ClaimedLabels'
import Clients from './pages/Clients'
import Devices from './pages/Devices'
import Manufacturers from './pages/Manufacturers'
import Products from './pages/Products'
import Series from './pages/Series'
import Settings from './pages/Settings'

// CROCUS
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import BusinessIcon from '@mui/icons-material/Business'
import GroupsIcon from '@mui/icons-material/Groups'
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic'
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom'
import MonitorHeart from '@mui/icons-material/MonitorHeart'
import MusicNoteIcon from '@mui/icons-material/MusicNote'
import PeopleAlt from '@mui/icons-material/PeopleAlt'
import SettingsIcon from '@mui/icons-material/Settings'
import SportsMmaIcon from '@mui/icons-material/SportsMma'


import GymDevices from './pages/GymDevices'
import Gyms from './pages/Gyms'
import Music from './pages/Music'
import MusicWorkouts from './pages/MusicWorkouts'
import Rooms from './pages/Rooms'
import Users from './pages/Users'
import WorkoutGroups from './pages/WorkoutGroups'
//



import { useCollection, useUser } from './pb'

const drawerWidth = 300

const VersionInfoBase = (props) => {
  const [serVer, setSerVer] = useState('version')
  useEffect(() => {
    getServerVersion()
      .then(setSerVer)
      .catch(() => setSerVer('unknown'))
  }, [])
  return <div {...props} title={'JS build ' + __BUILD_DATE__}>{serVer}</div>
}

const VersionInfo = styled(VersionInfoBase)`
  font-size: 0.7rem;
  text-align: center;
  width: 100%;
  overflow: visible;
  z-index: 100;
  color: #8888;
  margin: 0;
`

const ProductsPage = () => {
  const [labelsObj, labelsLoaded] = useCollection('labels')
  const labels = Object.values(labelsObj)
  return (
    <MapRoot >
      <Paper>
        <DataGrid
          rows={labels}
          columns={columns}
          initialState={{ pagination: { paginationModel } }}
          pageSizeOptions={[10, 50]}
        />
      </Paper>
    </MapRoot>
  )
}

const UserListItemText = styled(ListItemText)`
  * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const UserListItem = ({ page, selected }) => {
  const { user, logout } = useUser()
  const Icon = page.icon
  return (
    <ListItem disablePadding secondaryAction={
      <IconButton edge="end" onClick={logout}>
        <LogoutIcon />
      </IconButton>
    }>
      <ListItemButton component={Link} href={page.url} selected={selected}>
        <ListItemIcon>
          {Icon && <Icon />}
        </ListItemIcon>
        <UserListItemText primary={user.name || user.username} />
      </ListItemButton>
    </ListItem>
  )
}


export const pages = {
  account: {
    title: 'Аккаунт',
    icon: AccountCircleIcon,
    content: Account,
    // render: (page, selected) => <UserListItem key={page.name} page={page} selected={selected} />
  },
  settings: {
    title: 'Настройки',
    icon: SettingsIcon,
    content: Settings,
    // render: (page, selected) => <UserListItem key={page.name} page={page} selected={selected} />
  },
  mobile: {
    title: 'Тренировка',
    icon: MonitorHeart,
    url: "~/app"
  },
  devices: {
    title: 'Устройства',
    icon: DeveloperBoardIcon,
    content: Devices,
  },
  manufacturers: {
    title: 'Призводители',
    icon: FactoryIcon,
    content: Manufacturers,
  },
  clients: {
    title: 'Клиенты',
    icon: StoreIcon,
    content: Clients,
  },
  
  products: {
    title: 'Продукция',
    icon: MapIcon,
    content: Products,
  },
  series: {
    title: 'Серии',
    icon: PrecisionManufacturingIcon,
    content: Series,
  },
  labels: {
    title: 'Метки',
    icon: SellIcon,
    content: ClaimedLabels,
  },
  help: {
    title: 'Справка',
    icon: HelpCenterIcon,
    content: null,
  },

  music: {
    title: 'Треки',
    icon: MusicNoteIcon,
    content: Music,
  },
  musicworkouts: {
    title: 'Типовые тренировки',
    icon: LibraryMusicIcon,
    content: MusicWorkouts,
  },
  groupworkouts: {
    title: 'Групповые тренировки',
    icon: GroupsIcon,
    content: WorkoutGroups,
  },
  gyms: {
    title: 'Тренажёрки',
    icon: BusinessIcon,
    content: Gyms,
  },
  rooms: {
    title: 'Залы',
    icon: MeetingRoomIcon,
    content: Rooms,
  },
  gymdevices: {
    title: 'Устройства',
    icon: SportsMmaIcon,
    content: GymDevices,
  },
  users: {
    title: 'Пользователи',
    icon: PeopleAlt,
    content: Users,
  },
}
Object.entries(pages).forEach(([name, conf]) => {
  conf.name = name
  conf.url = conf.url ? conf.url : '/' + name
})


const PageRoot = styled.div`
`

function MainMenuDrawer({ currentPage }) {

  const menuPages = [[
    pages.music,
    pages.musicworkouts,
    pages.groupworkouts,
    // pages.devices,
  ],
  [
    pages.gyms,
    pages.rooms,
    pages.gymdevices,
  ],
  [
    pages.users,
    pages.settings,
    pages.account,
  ],[
    pages.mobile
  ]
  // [
  //   pages.manufacturers,
  //   pages.products,
  //   pages.series,
  // ], [
  //   pages.clients,
  //   pages.labels,
  // ], 
  // [
    //pages.help,
  // ]
]

  return <>
    <Toolbar sx={{ p: 2, display: "flex", alignContent: "center", justifyContent: "center" }} >
      <a href="/">
        <img src="/logo.webp" />
      </a>
    </Toolbar>
    {menuPages.map((section, sectionIndex) =>
      <Fragment key={sectionIndex}>
        <Divider />
        <List>
          {section.map(page => {
            const Icon = page.icon
            return page.render ? page.render(page, page.name === currentPage) : (
              <ListItem key={page.name} disablePadding>
                <ListItemButton component={Link} href={page.url} selected={page.name === currentPage}>
                  <ListItemIcon>
                    {Icon && <Icon />}
                  </ListItemIcon>
                  <ListItemText primary={page.title} />
                </ListItemButton>
              </ListItem>
            )
          })}
        </List>
      </Fragment>
    )}
    <div style={{ flex: 1 }} />
    <VersionInfo />
  </>
}

function App({ currentPage }) {
  const [mobileOpen, setMobileOpen] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  const handleDrawerClose = () => {
    setIsClosing(true)
    setMobileOpen(false)
  }

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false)
  }

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen)
    }
  }

  const mainMenuDrawer = <MainMenuDrawer currentPage={currentPage} />

  const PageComponent = pages[currentPage]?.content || (() => `[${currentPage}]`)

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar sx={{ display: 'flex' }}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {pages[currentPage].title || 'Untitled page'}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onTransitionEnd={handleDrawerTransitionEnd}
          onClose={handleDrawerClose}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
          slotProps={{
            root: {
              keepMounted: true, // Better open performance on mobile.
            },
          }}
        >
          {mainMenuDrawer}
        </Drawer>
        <Drawer
          open
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {mainMenuDrawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
      >
        <Toolbar />
        <PageRoot className="content">
          <PageComponent key={currentPage} {...pages[currentPage]} />
        </PageRoot>
      </Box>
    </Box>
  )
}

const MapRoot = styled.div`
`


const columns = [
  //{ field: 'index', headerName: '№', width: 70 },
  { field: 'name', headerName: 'Наим', width: 130 },
  { field: 'client', headerName: 'Клиент', width: 130 },
  { field: 'id', headerName: 'Код', width: 320, valueGetter: v => v.toUpperCase().replace(/-/g, ' '), cellClassName: 'code' },
  { field: 'status', headerName: 'Статус', width: 150, valueGetter: (v, row) => row.used ? 'Использовано' : '' },
]

const paginationModel = { page: 0, pageSize: 10 }

const coords = [{ x: 125, y: 264 }, { x: 118, y: 267 }, { x: 117, y: 274 }, { x: 128, y: 283 }, { x: 255, y: 363 }, { x: 252, y: 378 }, { x: 276, y: 251 }, { x: 906, y: 155 }, { x: 954, y: 363 }, { x: 826, y: 550 }, { x: 510, y: 394 }, { x: 53, y: 381 }, { x: 83, y: 361 }, { x: 33, y: 175 }, { x: 213, y: 185 }]

const rows = new Array(coords.length).fill({}).map((v, i) => ({
  ...v,
  name: 'Косметика №43',
  client: 'ООО Ромашка',
  uuid: String(i),//crypto.randomUUID(),
  x: coords[i % coords.length].x,
  y: coords[i % coords.length].y,
}))

rows[3].used = true
rows[5].used = true
rows[6].used = true


export default App